import { useEffect, useRef } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { takeOAuthReturn } from '@/lib/oauth-return'

export const Route = createFileRoute('/oauth/resume')({
  component: ResumePage,
  head: () => ({ meta: [{ title: 'Continuing — Uptrack' }, { name: 'robots', content: 'noindex' }] }),
})

// After sign-in, continue the MCP authorization that sent the user to login.
function ResumePage() {
  // takeOAuthReturn empties the store, and React can run an effect twice in development.
  const started = useRef(false)
  useEffect(() => {
    if (started.current) return
    started.current = true
    window.location.replace(takeOAuthReturn() ?? '/dashboard')
  }, [])
  return <p className="p-10 text-center text-muted-foreground">Continuing…</p>
}
